import { CalculationEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <CalculationEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};